/* eslint-disable no-unused-vars */
import React from 'react';
import AccountStepper from '../../Common/Profile/AccountStepper';
import { hot } from 'react-hot-loader';

export default hot(module)(function AccountSetupSteps({
	userId = '',
	error = '',
	redirectToKyc = () => {},
	redirectTodwollaPlaid = () => {},
	toDashBoard = () => {},
	kycStatus = {},
	loading = false
}) {
	return (
		<AccountStepper
			error={error}
			submission_date={kycStatus?.submission_date ? true : false}
			hasWallet={kycStatus?.wallet_connected}
			exclaimation={
				(kycStatus?.wallet_connected && !kycStatus?.submission_date) || kycStatus?.kyc_status === 'Rejected'
			}
			loading={loading}
			redirectTodwollaPlaid={redirectTodwollaPlaid}
			redirectToKyc={redirectToKyc}
			toDashBoard={toDashBoard}
			userid={userId}
			approved={kycStatus?.kyc_status === 'Approved'}
			pending={kycStatus?.kyc_status === 'Pending'}
			data={kycStatus}
		/>
	);
});
